/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Message } from '../models';
// @ts-ignore
import { Sendungsstatus } from '../models';
/**
 * SendungsstatusService - axios parameter creator
 * @export
 */
export const SendungsstatusServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Erstellt einen neuen Anzeigestatus
         * @summary status
         * @param {Sendungsstatus} [sendungsstatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStatus: async (sendungsstatus?: Sendungsstatus, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sendungsstati/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendungsstatus, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Löscht einen Anzeigestatus
         * @summary status
         * @param {number} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStatus: async (body?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sendungsstati`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert eine Liste von Anzeigestati
         * @summary Anzeigestati
         * @param {string} searchString 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnzeigestati: async (searchString: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchString' is not null or undefined
            assertParamExists('getAnzeigestati', 'searchString', searchString)
            const localVarPath = `/api/sendungsstati/anzeigestati-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert eine Liste der Default-Anzeigestati.
         * @summary Defaultstatuskette
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultstatuskette: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sendungsstati/defaultstatuskette`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert eine Liste von Sendungsstati, die keinem Anzeigestatus zugeordnet sind .
         * @summary freie Sendungsstati
         * @param {string} searchString 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreieSendungsstati: async (searchString: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchString' is not null or undefined
            assertParamExists('getFreieSendungsstati', 'searchString', searchString)
            const localVarPath = `/api/sendungsstati/freie-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert eine Liste von Sendungsstati
         * @summary Sendungsstati
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSendungsstati: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sendungsstati`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert eine Liste aller zugeordneten Sendungsstati für einen Anzeigestati
         * @summary Anzeigestati
         * @param {number} id 
         * @param {string} searchString 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSendungsstatiByAnzeigestati: async (id: number, searchString: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSendungsstatiByAnzeigestati', 'id', id)
            // verify required parameter 'searchString' is not null or undefined
            assertParamExists('getSendungsstatiByAnzeigestati', 'searchString', searchString)
            const localVarPath = `/api/sendungsstati/anzeigestati/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert einen Status
         * @summary Status
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatus: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getStatus', 'id', id)
            const localVarPath = `/api/sendungsstati/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Editiert die Statuskette
         * @summary status
         * @param {Array<Sendungsstatus>} [sendungsstatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setStatuskette: async (sendungsstatus?: Array<Sendungsstatus>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sendungsstati/updateStatuskette`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendungsstatus, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Editiert einen Anzeigestatus
         * @summary status
         * @param {Sendungsstatus} [sendungsstatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStatus: async (sendungsstatus?: Sendungsstatus, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sendungsstati/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendungsstatus, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SendungsstatusService - functional programming interface
 * @export
 */
export const SendungsstatusServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SendungsstatusServiceAxiosParamCreator(configuration)
    return {
        /**
         * Erstellt einen neuen Anzeigestatus
         * @summary status
         * @param {Sendungsstatus} [sendungsstatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createStatus(sendungsstatus?: Sendungsstatus, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sendungsstatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createStatus(sendungsstatus, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Löscht einen Anzeigestatus
         * @summary status
         * @param {number} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteStatus(body?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sendungsstatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteStatus(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert eine Liste von Anzeigestati
         * @summary Anzeigestati
         * @param {string} searchString 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnzeigestati(searchString: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Sendungsstatus>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnzeigestati(searchString, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert eine Liste der Default-Anzeigestati.
         * @summary Defaultstatuskette
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDefaultstatuskette(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Sendungsstatus>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDefaultstatuskette(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert eine Liste von Sendungsstati, die keinem Anzeigestatus zugeordnet sind .
         * @summary freie Sendungsstati
         * @param {string} searchString 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFreieSendungsstati(searchString: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Sendungsstatus>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreieSendungsstati(searchString, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert eine Liste von Sendungsstati
         * @summary Sendungsstati
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSendungsstati(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Sendungsstatus>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSendungsstati(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert eine Liste aller zugeordneten Sendungsstati für einen Anzeigestati
         * @summary Anzeigestati
         * @param {number} id 
         * @param {string} searchString 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSendungsstatiByAnzeigestati(id: number, searchString: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Sendungsstatus>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSendungsstatiByAnzeigestati(id, searchString, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert einen Status
         * @summary Status
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatus(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sendungsstatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStatus(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Editiert die Statuskette
         * @summary status
         * @param {Array<Sendungsstatus>} [sendungsstatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setStatuskette(sendungsstatus?: Array<Sendungsstatus>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sendungsstatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setStatuskette(sendungsstatus, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Editiert einen Anzeigestatus
         * @summary status
         * @param {Sendungsstatus} [sendungsstatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStatus(sendungsstatus?: Sendungsstatus, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sendungsstatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStatus(sendungsstatus, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SendungsstatusService - factory interface
 * @export
 */
export const SendungsstatusServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SendungsstatusServiceFp(configuration)
    return {
        /**
         * Erstellt einen neuen Anzeigestatus
         * @summary status
         * @param {Sendungsstatus} [sendungsstatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStatus(sendungsstatus?: Sendungsstatus, options?: any): AxiosPromise<Sendungsstatus> {
            return localVarFp.createStatus(sendungsstatus, options).then((request) => request(axios, basePath));
        },
        /**
         * Löscht einen Anzeigestatus
         * @summary status
         * @param {number} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStatus(body?: number, options?: any): AxiosPromise<Sendungsstatus> {
            return localVarFp.deleteStatus(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert eine Liste von Anzeigestati
         * @summary Anzeigestati
         * @param {string} searchString 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnzeigestati(searchString: string, options?: any): AxiosPromise<Array<Sendungsstatus>> {
            return localVarFp.getAnzeigestati(searchString, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert eine Liste der Default-Anzeigestati.
         * @summary Defaultstatuskette
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultstatuskette(options?: any): AxiosPromise<Array<Sendungsstatus>> {
            return localVarFp.getDefaultstatuskette(options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert eine Liste von Sendungsstati, die keinem Anzeigestatus zugeordnet sind .
         * @summary freie Sendungsstati
         * @param {string} searchString 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreieSendungsstati(searchString: string, options?: any): AxiosPromise<Array<Sendungsstatus>> {
            return localVarFp.getFreieSendungsstati(searchString, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert eine Liste von Sendungsstati
         * @summary Sendungsstati
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSendungsstati(options?: any): AxiosPromise<Array<Sendungsstatus>> {
            return localVarFp.getSendungsstati(options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert eine Liste aller zugeordneten Sendungsstati für einen Anzeigestati
         * @summary Anzeigestati
         * @param {number} id 
         * @param {string} searchString 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSendungsstatiByAnzeigestati(id: number, searchString: string, options?: any): AxiosPromise<Array<Sendungsstatus>> {
            return localVarFp.getSendungsstatiByAnzeigestati(id, searchString, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert einen Status
         * @summary Status
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatus(id: number, options?: any): AxiosPromise<Sendungsstatus> {
            return localVarFp.getStatus(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Editiert die Statuskette
         * @summary status
         * @param {Array<Sendungsstatus>} [sendungsstatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setStatuskette(sendungsstatus?: Array<Sendungsstatus>, options?: any): AxiosPromise<Sendungsstatus> {
            return localVarFp.setStatuskette(sendungsstatus, options).then((request) => request(axios, basePath));
        },
        /**
         * Editiert einen Anzeigestatus
         * @summary status
         * @param {Sendungsstatus} [sendungsstatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStatus(sendungsstatus?: Sendungsstatus, options?: any): AxiosPromise<Sendungsstatus> {
            return localVarFp.updateStatus(sendungsstatus, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SendungsstatusService - interface
 * @export
 * @interface SendungsstatusService
 */
export interface SendungsstatusServiceInterface {
    /**
     * Erstellt einen neuen Anzeigestatus
     * @summary status
     * @param {Sendungsstatus} [sendungsstatus] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SendungsstatusServiceInterface
     */
    createStatus(sendungsstatus?: Sendungsstatus, options?: any): AxiosPromise<Sendungsstatus>;

    /**
     * Löscht einen Anzeigestatus
     * @summary status
     * @param {number} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SendungsstatusServiceInterface
     */
    deleteStatus(body?: number, options?: any): AxiosPromise<Sendungsstatus>;

    /**
     * Liefert eine Liste von Anzeigestati
     * @summary Anzeigestati
     * @param {string} searchString 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SendungsstatusServiceInterface
     */
    getAnzeigestati(searchString: string, options?: any): AxiosPromise<Array<Sendungsstatus>>;

    /**
     * Liefert eine Liste der Default-Anzeigestati.
     * @summary Defaultstatuskette
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SendungsstatusServiceInterface
     */
    getDefaultstatuskette(options?: any): AxiosPromise<Array<Sendungsstatus>>;

    /**
     * Liefert eine Liste von Sendungsstati, die keinem Anzeigestatus zugeordnet sind .
     * @summary freie Sendungsstati
     * @param {string} searchString 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SendungsstatusServiceInterface
     */
    getFreieSendungsstati(searchString: string, options?: any): AxiosPromise<Array<Sendungsstatus>>;

    /**
     * Liefert eine Liste von Sendungsstati
     * @summary Sendungsstati
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SendungsstatusServiceInterface
     */
    getSendungsstati(options?: any): AxiosPromise<Array<Sendungsstatus>>;

    /**
     * Liefert eine Liste aller zugeordneten Sendungsstati für einen Anzeigestati
     * @summary Anzeigestati
     * @param {number} id 
     * @param {string} searchString 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SendungsstatusServiceInterface
     */
    getSendungsstatiByAnzeigestati(id: number, searchString: string, options?: any): AxiosPromise<Array<Sendungsstatus>>;

    /**
     * Liefert einen Status
     * @summary Status
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SendungsstatusServiceInterface
     */
    getStatus(id: number, options?: any): AxiosPromise<Sendungsstatus>;

    /**
     * Editiert die Statuskette
     * @summary status
     * @param {Array<Sendungsstatus>} [sendungsstatus] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SendungsstatusServiceInterface
     */
    setStatuskette(sendungsstatus?: Array<Sendungsstatus>, options?: any): AxiosPromise<Sendungsstatus>;

    /**
     * Editiert einen Anzeigestatus
     * @summary status
     * @param {Sendungsstatus} [sendungsstatus] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SendungsstatusServiceInterface
     */
    updateStatus(sendungsstatus?: Sendungsstatus, options?: any): AxiosPromise<Sendungsstatus>;

}

/**
 * SendungsstatusService - object-oriented interface
 * @export
 * @class SendungsstatusService
 * @extends {BaseAPI}
 */
export class SendungsstatusService extends BaseAPI implements SendungsstatusServiceInterface {
    /**
     * Erstellt einen neuen Anzeigestatus
     * @summary status
     * @param {Sendungsstatus} [sendungsstatus] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SendungsstatusService
     */
    public createStatus(sendungsstatus?: Sendungsstatus, options?: any) {
        return SendungsstatusServiceFp(this.configuration).createStatus(sendungsstatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Löscht einen Anzeigestatus
     * @summary status
     * @param {number} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SendungsstatusService
     */
    public deleteStatus(body?: number, options?: any) {
        return SendungsstatusServiceFp(this.configuration).deleteStatus(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert eine Liste von Anzeigestati
     * @summary Anzeigestati
     * @param {string} searchString 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SendungsstatusService
     */
    public getAnzeigestati(searchString: string, options?: any) {
        return SendungsstatusServiceFp(this.configuration).getAnzeigestati(searchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert eine Liste der Default-Anzeigestati.
     * @summary Defaultstatuskette
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SendungsstatusService
     */
    public getDefaultstatuskette(options?: any) {
        return SendungsstatusServiceFp(this.configuration).getDefaultstatuskette(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert eine Liste von Sendungsstati, die keinem Anzeigestatus zugeordnet sind .
     * @summary freie Sendungsstati
     * @param {string} searchString 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SendungsstatusService
     */
    public getFreieSendungsstati(searchString: string, options?: any) {
        return SendungsstatusServiceFp(this.configuration).getFreieSendungsstati(searchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert eine Liste von Sendungsstati
     * @summary Sendungsstati
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SendungsstatusService
     */
    public getSendungsstati(options?: any) {
        return SendungsstatusServiceFp(this.configuration).getSendungsstati(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert eine Liste aller zugeordneten Sendungsstati für einen Anzeigestati
     * @summary Anzeigestati
     * @param {number} id 
     * @param {string} searchString 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SendungsstatusService
     */
    public getSendungsstatiByAnzeigestati(id: number, searchString: string, options?: any) {
        return SendungsstatusServiceFp(this.configuration).getSendungsstatiByAnzeigestati(id, searchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert einen Status
     * @summary Status
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SendungsstatusService
     */
    public getStatus(id: number, options?: any) {
        return SendungsstatusServiceFp(this.configuration).getStatus(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Editiert die Statuskette
     * @summary status
     * @param {Array<Sendungsstatus>} [sendungsstatus] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SendungsstatusService
     */
    public setStatuskette(sendungsstatus?: Array<Sendungsstatus>, options?: any) {
        return SendungsstatusServiceFp(this.configuration).setStatuskette(sendungsstatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Editiert einen Anzeigestatus
     * @summary status
     * @param {Sendungsstatus} [sendungsstatus] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SendungsstatusService
     */
    public updateStatus(sendungsstatus?: Sendungsstatus, options?: any) {
        return SendungsstatusServiceFp(this.configuration).updateStatus(sendungsstatus, options).then((request) => request(this.axios, this.basePath));
    }
}
